import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth/auth.guard';

export const APP_ROUTES: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/menu/menu-routes').then((m) => m.MENU_ROUTING),
    },
    {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-routes').then((m) => m.AUTH_ROUTES),
    },
    {
        path: 'login',
        redirectTo: 'auth/login',
        pathMatch: 'full',
    },
];
